import { defineMessages } from 'react-intl';

export default defineMessages({
    policies: {
        id: 'e1p.gateway.views.policy-landing.Policies',
        defaultMessage: 'Policies',
    },
    recentlyIssuedPolicyForPastXDays: {
        id: 'e1p.gateway.views.Recently Issued Policies for past x days',
        defaultMessage: 'Recently Issued Policies for past {value} days',
    },
    recentlyViewedPolicies: {
        id: 'e1p.gateway.views.policy-landing.RecentlyViewedPolicies',
        defaultMessage: 'Recently Viewed Policies'
    },
    recentlyViewed: {
        id: 'e1p.gateway.views.policy-landing.Recently Viewed',
        defaultMessage: 'Recently Viewed',
    },
    recentlyIssued: {
        id: 'e1p.gateway.views.policy-landing.Recently Issued',
        defaultMessage: 'Recently Issued',
    },
    openQuotes: {
        id: 'e1p.gateway.views.policy-landing.Open Quotes',
        defaultMessage: 'Open Quotes',
    },
    openChanges: {
        id: 'e1p.gateway.views.policy-landing.Open Changes',
        defaultMessage: 'Open Changes'
    },
    openCancellations: {
        id: 'e1p.gateway.views.policy-landing.Open Cancellations',
        defaultMessage: 'Open Cancellations'
    },
    openRenewals: {
        id: 'e1p.gateway.views.policy-landing.Open Renewals',
        defaultMessage: 'Open Renewals'
    },
    product: {
        id: 'e1p.gateway.views.policy-landing.Product',
        defaultMessage: 'Product'
    },
    status: {
        id: 'e1p.gateway.views.policy-landing.Status',
        defaultMessage: 'Status'
    },
    policyNumber: {
        id: 'e1p.gateway.views.policy-landing.PolicyNumber',
        defaultMessage: 'Policy Number'
    },
    account: {
        id: 'e1p.gateway.views.policy-landing.Account',
        defaultMessage: 'Account'
    },
    accountNumber: {
        id: 'e1p.gateway.views.policy-landing.Account Number',
        defaultMessage: 'Account Number'
    },
    namedInsured: {
        id: 'e1p.gateway.views.policy-landing.NamedInsured',
        defaultMessage: 'Named Insured'
    },
    inGoodStanding: {
        id: 'e1p.gateway.views.policy-landing.In Good Standing',
        defaultMessage: 'In Good Standing'
    },
    billingStatus: {
        id: 'e1p.gateway.views.policy-landing.Billing Status',
        defaultMessage: 'Billing Status'
    },
    policyLandingQuotes: {
        id: 'e1p.gateway.views.policy-landing.Quotes',
        defaultMessage: 'Quotes'
    },
    policyLandingRenewal: {
        id: 'e1p.gateway.views.policy-landing.Renewal',
        defaultMessage: 'Renewal'
    },
    policyLandingChange: {
        id: 'e1p.gateway.views.policy-landing.Change',
        defaultMessage: 'Change'
    },
    policyLandingCancellation: {
        id: 'e1p.gateway.views.policy-landing.Cancellation',
        defaultMessage: 'Cancellation'
    },
    quickFilter: {
        id: 'e1p.gateway.views.policy-landing.Quick Filters',
        defaultMessage: 'Quick Filters'
    },
    advancedFilter: {
        id: 'e1p.gateway.views.policy-landing.Advanced Filter',
        defaultMessage: 'Advanced Filter'
    },
    switchTo: {
        id: 'e1p.gateway.views.policy-landing.Switch to',
        defaultMessage: 'Switch to'
    },
    premium: {
        id: 'e1p.gateway.views.policy-landing.Premium',
        defaultMessage: 'Premium'
    },
    created: {
        id: 'e1p.gateway.views.policy-landing.Created',
        defaultMessage: 'Created'
    },
    jobNumber: {
        id: 'e1p.gateway.views.policy-landing.Quote Number',
        defaultMessage: 'Quote Number'
    },
    jobStatus: {
        id: 'e1p.gateway.views.policy-landing.Job Status',
        defaultMessage: 'Job Status'
    },
    quotes: {
        id: 'e1p.gateway.views.policy-landing.Quotes',
        defaultMessage: 'Quotes'
    },
    renewal: {
        id: 'e1p.gateway.views.policy-landing.Renewal',
        defaultMessage: 'Renewal'
    },
    change: {
        id: 'e1p.gateway.views.policy-landing.Change',
        defaultMessage: 'Change'
    },
    cancellation: {
        id: 'e1p.gateway.views.policy-landing.Cancellation',
        defaultMessage: 'Cancellation'
    },
    accountTableHeading: {
        id: 'e1p.gateway.views.for past x days',
        defaultMessage: '{currentView} for past {value} days'
    },
    noResultsFound: {
        id: 'e1p.gateway.views.policy-landing.No results found for this filter',
        defaultMessage: 'No results found for this filter'
    },
    effectiveDate: {
        id: 'e1p.gateway.views.policy-landing.Effective Date',
        defaultMessage: 'Effective Date'
    },
    expirationDate: {
        id: 'e1p.gateway.views.policy-landing.Expiration Date',
        defaultMessage: 'Expiration Date'
    },
    accountNavigation: {
        id: 'e1p.gateway.navigation.breadcrumbs.Account: link',
        defaultMessage: 'Account: {link}'
    },
    contingenciesRetrieveErrorTitle: {
        id: 'e1p.gateway.policies.riskAnalysis.Error Retrieving Contingencies',
        defaultMessage: 'Error Retrieving Contingencies'
    },
    contingenciesRetrieveErrorMessage: {
        id: 'e1p.gateway.policies.riskAnalysis.An error occurred attempting to retrieving Contingencies.',
        defaultMessage: 'An error occurred attempting to retrieving Contingencies.'
    },
    contingenciesInfoMessage: {
        id: 'e1p.gateway.policy-landing.The policy has one or more outstanding contingencies',
        defaultMessage: 'The policy has one or more outstanding contingencies'
    },
    recentlyIssuedPolicy: {
        id: 'e1p.gateway.views.Recently Issued Policies',
        defaultMessage: 'Recently Issued Policies',
    },
});
